import { Action as SaveSharesInfo, SAVE_SHARES_INFO_ACTION } from "./investment/actions";
import { createStore } from "redux";
import { initialState, StoreState } from "./types";
import { saveSharesInfoReducer } from "./investment/reducers";

import { Action as PropertyAction, ADDED_ACTION, EDITED_ACTION, FETCHED_ALL_ACTION, DELETED_ACTION } from "./property/actions";

import {
  addedReducer,
  editedReducer,
  deletedReducer,
  fetchedAllReducer,
} from "./property/reducers";

import {
  Action as UserAction,
  REGISTER_USER_DETAILS_ACTION,
  LOGIN_ACTION,
  LOGOUT_ACTION,
  WHITELIST_USER_ACTION,
} from "./user/actions";

import {
  whitelistUserReducer,
  loginReducer,
  logoutReducer,
  registerUserDetailsReducer,
} from "./user/reducers";

type Action = PropertyAction | UserAction | SaveSharesInfo;

const reducer = (
  state: StoreState = initialState,
  action: Action
): StoreState => {
  switch (action.type) {
    case ADDED_ACTION:
      return addedReducer(state, action.payload.property);
    case EDITED_ACTION:
      return editedReducer(state, action.payload.property);
    case DELETED_ACTION:
      return deletedReducer(state, action.payload.id);
    case FETCHED_ALL_ACTION:
      return fetchedAllReducer(state, action.payload.properties);
    case LOGIN_ACTION:
      return loginReducer(state, action.payload.token);
    case LOGOUT_ACTION:
      return logoutReducer(state);
    case WHITELIST_USER_ACTION:
      return whitelistUserReducer(state, action.payload);
    case REGISTER_USER_DETAILS_ACTION:
      return registerUserDetailsReducer(state, action.payload);
    case SAVE_SHARES_INFO_ACTION:
      return saveSharesInfoReducer(state, action.payload.currentShare);
    default:
      return state;
  }
};

const windowDev = window as any;
// Need this line of code to use ReduxDevTool plugin
const reduxDevTools = (windowDev.__REDUX_DEVTOOLS_EXTENSION__ &&
  windowDev.__REDUX_DEVTOOLS_EXTENSION__()) as any;

export const RootStore = createStore(reducer, initialState, reduxDevTools);
